module.exports = "data:text/x-markdown;base64,VGhlIGdvYWwgb2YgdGhpcyBsZXZlbCBpcyB2ZXJ5IGVhc3kuIFRyeSB0byBzZXQgdmFyaWFibGUgYGNvbXBsZXRlYCB0byBgdHJ1ZWAhCgombmJzcDsKVGhpbmdzIHRoYXQgbWlnaHQgaGVscDoKKiBEbyB5b3UgdW5kZXJzdGFuZCBldmVyeSBzdGVwIGluIHRoZSBjb2RlPwo="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/encrypt.md
// module id = 1369
// module chunks = 0